import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from '@theme/layout/admin/admin.component';
import { GuestComponent } from '@theme/layout/guest/guest.component';
import { OrdersBranchGuard } from '@shared/guards/orders-branch.guard';
import { AuthGuard } from '@shared/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'panel',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./demo/pages/dashboard/dashboard.module').then(m => m.DashboardModule),
      },
      {
        path: 'restaurant',
        loadChildren: () =>
          import('./demo/pages/new-restaurant/new-restaurant.module').then(m => m.NewRestaurantModule),
      },
      {
        path: 'reservations',
        loadChildren: () =>
          import('./demo/pages/reservations/reservations.module').then(m => m.ReservationsModule),
      },
      {
        path: 'profile',
        loadChildren: () => import('./demo/pages/profile/profile.module').then(m => m.ProfileModule),
      },
      {
        path: 'staff',
        loadChildren: () => import('./demo/pages/users-page/users-page.module').then(m => m.UsersPageModule),
      },
      {
        path: 'orders',
        // Block direct access to orders when branch is MENU_ONLY
        canActivate: [OrdersBranchGuard],
        loadChildren: () => import('./demo/pages/new-orders/new-order.module').then(m => m.NewOrderModule),
      },
      {
        path: 'panel',
        loadChildren: () => import('./demo/pages/panel/panel.module').then(m => m.PanelModule),
      },
      {
        path: 'menus',
        loadChildren: () => import('./demo/pages/new-menus/new-menus.module').then(m => m.NewMenusModule),
      },
      {
        path: 'tables',
        loadChildren: () => import('./demo/pages/new-table/new-table.module').then(m => m.NewTableModule),
      },
      {
        path: 'terms-and-condition',
        loadChildren: () => import('./demo/pages/terms-and-condition/terms-and-condition.module').then(m => m.TermsAndConditionModule),
      },
      {
        path: 'review',
        loadChildren: () => import('./demo/pages/review/review.module').then(m =>m.ReviewModule),
      },
      {
        path:'notifications',
        loadChildren:()=>import('./demo/pages/notifications-page/notifications-page.module').then(m=>m.NotificationsPageModule)
      },
      {
        path: 'ai',
        loadChildren: () =>
          import('./demo/pages/ai-features/ai-features.module').then(m => m.AiFeaturesModule),
      }
    ],
  },
  {
    path: '',
    component: GuestComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () =>
          import('./demo/pages/authentication/authentication.module').then(m => m.AuthenticationModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
